var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"common":1,"src_app_create-customer_create-customer_tsx-src_app_components_buttons_button_module_scss-src-46843d":1,"default-src_app_footer_footer_tsx-src_app_components_buttons_button_module_scss":1,"src_app_package-list_package-list_tsx-src_app_components_cards_card_module_scss":1,"src_app_select_select-welcome_select-welcome_tsx-src_app_components_cards_card_module_scss":1,"default-src_app_payment_use-make-payment_ts-src_app_shared_product-confirm-card_product-confi-e0fe19":1,"src_app_product-detail_product-detail_tsx":1,"src_app_core_services_api_product-detail_ts-src_app_flex-product-detail_flex-product-detail_t-ed4948":1,"src_app_payment_make-payment_tsx-src_app_components_cards_card_module_scss":1,"src_app_payment_vodacom_vodacom-otp_vodacom-otp_tsx-src_app_components_cards_card_module_scss":1,"src_app_payment_vodacom_vodacom-details_vodacom-details_tsx-src_app_components_cards_card_mod-b5e8ce":1,"src_app_payment_vodacom_vodacom-payment-result_vodacom-payment-result_tsx-node_modules_babel_-738ab5":1,"src_app_components_buttons_button_module_scss":1,"src_app_payment_payment-result_voucher-fail_tsx-src_app_components_buttons_button_module_scss-c2d549":1,"src_app_payment_payment-result_select-payment-result_tsx-node_modules_babel_runtime_helpers_e-b4835d":1,"src_app_inactive-package_inactive-package_tsx-src_app_components_cards_card_module_scss":1,"vendors-node_modules_swiper_react_swiper-react_js-node_modules_swiper_modules_grid_grid_min_c-9b69dc":1,"src_app_action_action-overlay_tsx-src_app_components_buttons_button_module_scss-src_app_compo-9812a2":1,"src_app_flex-package-selection_flex-package-selection_tsx-src_app_components_cards_card_module_scss":1,"src_app_recommended-packages_recommended-packages_tsx":1,"src_app_capitec-redeem-voucher_capitec-redeem-voucher_tsx-src_app_components_buttons_button_tsx":1,"src_app_page-not-found_page-not-found_tsx-src_app_components_buttons_button_module_scss-src_a-67f8c6":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr